import escapeRegex from 'escape-string-regexp';
import Markdown from 'react-markdown';

import { Link } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { Bonus } from '../../../../types/bonus';
import { populateEmojis } from '../../../../utils/emoji';
import { useHashtagLink } from '../../../bonus-feed/features/recognition/hooks/useHashtagLink';
import { Route } from '../../config/router';
import { pathWithId } from '../../utils/api';
import { Chip } from '../Chip';

export const Amount = (text: string) => (
	<Chip data-testid="amount-chip" as="span">
		{text}
	</Chip>
);

export const Text = (text: string, highlight?: string) => {
	const highlighted = !highlight ? text : text.replace(new RegExp(escapeRegex(highlight), 'gi'), (match) => `**${match}**`);
	return (
		<>
			{/*
        The Markdown component unavoidably strips out trailing whitespace from the start of a string.
        If the string includes initial whitespace we need to manually add a space to be rendered.
      */}
			{highlighted.match(/^ /) && ' '}
			<Markdown
				components={{
					p: /* istanbul ignore next - Markdown component is mocked */ ({ children }) => <>{children}</>,
				}}
			>
				{populateEmojis(highlighted)}
			</Markdown>
			{/*
        The Markdown component unavoidably strips out trailing whitespace from the end of a string also 🤡
        If the string includes trailing whitespace we need to manually add a space to be rendered.
      */}
			{highlighted.match(/ $/) && ' '}
		</>
	);
};

export const Mention = (text: string, bonus: Bonus) => {
	const recognizeURL = useBuildRecognizeURL();
	const user = bonus?.receivers?.find(({ slug }) => slug && text.includes(slug));

	if (!user) {
		return Text(text);
	}

	return (
		<Link color="blue.500" fontWeight="medium" href={recognizeURL(pathWithId(Route.UserProfile, user.id))}>
			{text}
		</Link>
	);
};

export const Hashtag = (text: string) => {
	const hashtagLinkUrl = useHashtagLink(text);

	return (
		<Link href={hashtagLinkUrl} color="hashtag.fg" fontWeight="medium" _hover={{ color: 'hashtag.fgHover' }}>
			{text}
		</Link>
	);
};
